export const NoRender: React.FunctionComponent = () => {
	return null;
}